<template>
    <froala :tag="'textarea'" :config="config" v-model="content.content"></froala>
    <!--<textarea v-model="content.content"></textarea>-->
</template>

<script>
import { BASE_URL } from '../../http';
import 'froala-editor/css/froala_editor.pkgd.min.css';

export default {
  name: 'froala-tmp',

  props: ['height', 'content', 'upload_code', 'buttons'],

  mounted() {
    // let editor = $(this.$el).froalaEditor();
    // editor.on('froalaEditor.contentChanged', (e, editor) => {
    //     this.content.content = editor.html.get();
    // });
    // editor.on('froalaEditor.image.error', function (e, editor, error, response) {
    //     console.log(error, response);
    // });
  },

  computed: {
    config() {
      return {
        height: this.height,

        imageUploadURL: BASE_URL + '/images/upload',
        imageUploadParam: 'image',
        imageUploadMethod: 'POST',
        imageMaxSize: 5 * 1024 * 1024,
        imageAllowedTypes: ['jpeg', 'jpg', 'png'],
        imageUploadParams: {
          upload_code: this.upload_code,
        },

        fileUpload: false,
        videoUpload: false,

        htmlAllowedEmptyTags: ['textarea', 'a', 'iframe', 'object', 'video', 'style', '.fa', 'contact-us-form'],

        htmlDoNotWrapTags: ['contact-us-form'],

        htmlAllowedTags: [
          'a',
          'abbr',
          'address',
          'area',
          'article',
          'aside',
          'audio',
          'b',
          'base',
          'bdi',
          'bdo',
          'blockquote',
          'br',
          'button',
          'canvas',
          'caption',
          'cite',
          'code',
          'col',
          'colgroup',
          'datalist',
          'dd',
          'del',
          'details',
          'dfn',
          'dialog',
          'div',
          'dl',
          'dt',
          'em',
          'embed',
          'fieldset',
          'figcaption',
          'figure',
          'footer',
          'form',
          'h1',
          'h2',
          'h3',
          'h4',
          'h5',
          'h6',
          'header',
          'hgroup',
          'hr',
          'i',
          'iframe',
          'img',
          'input',
          'ins',
          'kbd',
          'keygen',
          'label',
          'legend',
          'li',
          'link',
          'main',
          'map',
          'mark',
          'menu',
          'menuitem',
          'meter',
          'nav',
          'noscript',
          'object',
          'ol',
          'optgroup',
          'option',
          'output',
          'p',
          'param',
          'pre',
          'progress',
          'queue',
          'rp',
          'rt',
          'ruby',
          's',
          'samp',
          'script',
          'style',
          'section',
          'select',
          'small',
          'source',
          'span',
          'strike',
          'strong',
          'sub',
          'summary',
          'sup',
          'table',
          'tbody',
          'td',
          'textarea',
          'tfoot',
          'th',
          'thead',
          'time',
          'title',
          'tr',
          'track',
          'u',
          'ul',
          'var',
          'video',
          'wbr',
          'contact-us-form',
        ],

        pluginsEnabled: [
          'align',
          'charCounter',
          'codeBeautifier',
          'codeView',
          'colors',
          'draggable',
          'entities',
          'fontFamily',
          'fontSize',
          'fullscreen',
          'image',
          'inlineStyle',
          'lineBreaker',
          'link',
          'lists',
          'paragraphFormat',
          'paragraphStyle',
          'quote',
          'table',
          'url',
          'wordPaste',
        ],

        toolbarButtons: this.buttons || [
          'fullscreen',
          'bold',
          'italic',
          'underline',
          'strikeThrough',
          'subscript',
          'superscript',
          '|',
          'fontFamily',
          'fontSize',
          'color',
          'inlineStyle',
          'paragraphStyle',
          '|',
          'paragraphFormat',
          'align',
          'formatOL',
          'formatUL',
          'outdent',
          'indent',
          'quote',
          '-',
          'insertLink',
          'insertImage',
          'insertVideo',
          'embedly',
          'insertTable',
          '|',
          'specialCharacters',
          'insertHR',
          'selectAll',
          'clearFormatting',
          '|',
          'print',
          'spellChecker',
          'help',
          'html',
          '|',
          'undo',
          'redo',
        ],
      };
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/FroalaTmp.vue